import { Box } from "@mui/material";
import { StyledContainer, StyledGridContainer } from "./Gallery.style";
import { GallarySwiper } from "./Gallary.swiper";
import { useBreak } from "hooks/useBreak";
import { getFocus, useGet } from "state/jotai";
import { active_project } from "state/store.global";
import { _project } from "state/store.projects";

export const MultiProjectImages = ({ images, setActiveGlry, activeGlry }) => {
        const { pin, pid } = useGet(active_project);
        const buttonsLabel = getFocus(_project, "buttonsLabel")?.[pin]?.[pid] ?? [];
        const isDesktop    = useBreak("md_up");

    return <StyledContainer style = {{ padding: isDesktop ? "20px 96px 40px" : "16px 0 0 16px" }}>
            <StyledGridContainer>
                        <p             className  = "h3">  { buttonsLabel?.filter((btn) => btn.UILabelProperty === "VaelgEjendom")[0]?.Label }</p>
                        <Box           sx         = {{ mt: 3 }}>
                        <GallarySwiper activeGlry = {activeGlry} images = {images} setActiveGlry = {setActiveGlry} />
                        </Box>
            </StyledGridContainer>
         </StyledContainer>
}